import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProfileInformationData } from "@myProfile/models";

export type AddContactStep = 1 | 2;

export const EMPTY_ADD_CONTACT_PROFILE: ProfileInformationData = {
  firstName: "",
  middleName: null,
  lastName: "",
  email: "",
  contactNumber: null,
  country: null,
  registeredAddress: null,
  stateProvince: null,
  city: null,
  postalCode: null,
  contactManagedBy: null,
  isGroupEmail: false,
  groupName: null,
};

export interface ContactFundAssignment {
  fundGlobalId: string;
  fundName: string;
  roles: string[];
  documentAccess: string[];
  notifications: string[];
}

export interface ContactAccountAssignment {
  accountGlobalId: string;
  accountName: string;
  funds: ContactFundAssignment[];
}

export interface AddContactDraft {
  profile: ProfileInformationData;
  assignments: ContactAccountAssignment[];
}

export interface AddContactState {
  open: boolean;
  step: AddContactStep;
  submitting: boolean;
  submitSuccess: boolean;
  draft: AddContactDraft;
}

export const addContactInitialState: AddContactState = {
  open: false,
  step: 1,
  submitting: false,
  submitSuccess: false,
  draft: { profile: EMPTY_ADD_CONTACT_PROFILE, assignments: [] },
};

const addContactSlice = createSlice({
  name: "addContact",
  initialState: addContactInitialState,
  reducers: {
    openAddContactDialog: () => ({ ...addContactInitialState, open: true }),
    closeAddContactDialog: (state) => {
      state.open = false;
    },
    setAddContactStep: (state, action: PayloadAction<AddContactStep>) => {
      state.step = action.payload;
    },
    updateAddContactDraft: (state, action: PayloadAction<Partial<AddContactDraft>>) => {
      state.draft = { ...state.draft, ...action.payload };
    },
    setAddContactSubmitting: (state, action: PayloadAction<boolean>) => {
      state.submitting = action.payload;
    },
    markAddContactSubmitted: (state) => {
      state.submitting = false;
      state.submitSuccess = true;
    },
    resetAddContactState: () => addContactInitialState,
  },
});

export const {
  openAddContactDialog,
  closeAddContactDialog,
  setAddContactStep,
  updateAddContactDraft,
  setAddContactSubmitting,
  markAddContactSubmitted,
  resetAddContactState,
} = addContactSlice.actions;

export default addContactSlice.reducer;
